<div class="c-change-app-menu" id="divChangeAppMenu">
  <a
    [href]="[moduleName + '/']"
    [id]="'aApp' + moduleName"
    mat-icon-button
    id="btnChangeApp"
    *hasPermission="[PERMISSION.MODULE_APP_ICON]"
  >
    <div class="c-app-icon-box">
      <div class="c-app-icon">
        <img id="imgLogo" [src]="'assets/images/logo-ROSS.svg'" />
      </div>
      <!-- <div class="c-app-text">
          {{moduleName}}
        </div> -->
    </div>
  </a>
  <!-- <mat-menu id="matMenuOption" #change_ross_app="matMenu">
    <mat-grid-list id="matGridList" cols="1" gutterSize="4px" rowHeight="50px">

      <ng-container *ngIf="organizations">
        <mat-grid-tile matRipple>
          <a [href]="" target="_blank">
            <div class="c-app-icon-box">
              <div class="c-app-icon">
                <img id="imgLogo" [src]="'assets/images/logo-ROSS.svg'" />
              </div>
              <div class="c-app-text">
                {{moduleName}}
              </div>
            </div>
          </a>
        </mat-grid-tile>
      </ng-container>
    </mat-grid-list>
  </mat-menu> -->
</div>
